"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _GridContainer = _interopRequireDefault(require("../../../layouts/grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("../../../layouts/grid/GridItem"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

var _ButtonDefault = _interopRequireDefault(require("../../../atoms/buttons/button/ButtonDefault"));

var _Image = _interopRequireDefault(require("../../../atoms/images/image/Image"));

var _BoxSizing = _interopRequireDefault(require("../../../layouts/box/boxSizing/BoxSizing"));

var _CardContainer = _interopRequireDefault(require("../../cards/cardContainer/CardContainer"));

var _AppTheme = _interopRequireDefault(require("../../../../AppTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlocksHero = function BlocksHero(_ref) {
  var primaryText = _ref.primaryText,
      buttonText = _ref.buttonText,
      buttonAction = _ref.buttonAction,
      imageUrl = _ref.imageUrl;
  var media = (0, _core.useMediaQuery)(_AppTheme.default.breakpoints.down('xs'));
  return /*#__PURE__*/_react.default.createElement(_CardContainer.default, {
    isSquare: true
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    alignItems: "center",
    disableGutters: true,
    direction: media ? "column-reverse" : "row"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    pl: "xxl",
    pr: "xxl"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3",
    text: primaryText
  }), /*#__PURE__*/_react.default.createElement(_ButtonDefault.default, {
    action: function action() {
      return buttonAction();
    },
    variant: "primary",
    title: buttonText
  }))), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12,
    sm: 8
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: imageUrl,
    ratio: "4x3"
  }))));
};

BlocksHero.propTypes = {
  primaryText: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  buttonAction: _propTypes.default.func.isRequired
};
BlocksHero.defaultProps = {
  primaryText: null,
  imageUrl: null,
  buttonText: null
};
var _default = BlocksHero;
exports.default = _default;